import React from "react"
import PropTypes from "prop-types"
import RegistryBadge from "components-design-system/badges/Badge/RegistryBadge/RegistryBadge"
import sampleRegistries from "../../../../stories/sample-data/sampleRegistries"
import "./ActionItemForms.scss"

const toNormalizedString = (str) => str?.toLowerCase().replace(/\s+/g, "")

const ActionItemForms = ({ data }) => {
  const formArray = data.forms.map((form) => {
    if (!form) return null
    // forms is array of strings
    if (typeof form === "string") return form
    // forms is array of objects
    else if (form.form_view && form.form_section) return `${form.form_view} ${form.form_section}`
    return null
  })

  return (
    <div className="action-item-forms-wrapper">
      {formArray.map((form, index) => {
        const matchedRegistry = sampleRegistries.find((registry) => {
          const matchedBadge = registry.badge && toNormalizedString(form).includes(toNormalizedString(registry.badge))
          return matchedBadge
        })

        const registries = matchedRegistry
          ? [{ ...matchedRegistry, name: form, badge: form }]
          : [{ name: form, region_name: "other", gpr_continent: null, badge: form }]

        return (
          <RegistryBadge
            key={index}
            value={form}
            registries={registries}
          />
        )
      })}
    </div>
  )
}

ActionItemForms.propTypes = {
  data: PropTypes.shape({
    forms: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          form_view: PropTypes.string,
          form_section: PropTypes.string,
        }),
      ])
    ),
    forms_count: PropTypes.number,
  }),
}

export default ActionItemForms
